/* eslint-disable react/prop-types */
import { MagnifyingGlassIcon, XCircleIcon } from '@heroicons/react/24/solid';
import usePlacesAutocomplete from 'use-places-autocomplete';
import { isEmptyData } from '../../../utils/helper';
import Result from '../Result';
import Saved from '../Saved';
import Recent from '../Recent';
import Map from '../Map';
import CurrentLocation from '../Current';
import { useState } from 'react';

const Search = (props) => {
	const {
		ready: isAutocompleteReady,
		value: search,
		suggestions: { data, status, loading },
		setValue: setSearch,
		clearSuggestions,
	} = usePlacesAutocomplete({
		requestOptions: { types: [] },
	});

	const [inputValue, setInputValue] = useState('');

	const handleSearch = () => {
		if (inputValue.trim().length < 3) return;

		setSearch(inputValue);
	};

	const handleCloseSearch = () => {
		setInputValue('');
		setSearch('');
		clearSuggestions();
	};

	return (
		<>
			<div className='flex items-center rounded-full border border-solid border-gray-200 h-8 gap-3 mb-2.5'>
				<MagnifyingGlassIcon className={`h-7 w-7 min-w-7 min-h-7 pl-2 text-gray-600`} strokeWidth={3} />
				<input
					placeholder='Cari alamat atau nama tempat'
					value={inputValue}
					onChange={(e) => setInputValue(e.target.value)}
					className='flex-auto w-full m-0 bg-transparent border-none outline-none text-xs font-normal'
					disabled={!isAutocompleteReady}
				/>
				{!isEmptyData(inputValue) && <XCircleIcon onClick={() => handleCloseSearch()} className='h-7 w-7 text-gray-500' />}
				<div onClick={handleSearch} className={`${!isEmptyData(inputValue) ? 'bg-[var(--rose-violet)] text-white' : 'bg-gray-400 text-white'} text-xs px-3 py-1.5 rounded-full`}>
					Cari
				</div>
			</div>
			{!isEmptyData(search) ? (
				<>
					<Result {...{ data, status, loading, ...props }} />
				</>
			) : (
				<>
					<div className='flex justify-between py-2 items-center'>
						<CurrentLocation {...props} />
						<Map />
					</div>
					<div className='h-2 w-full bg-light-house mb-4'></div>
					<Saved {...props} />
					<Recent {...props} />
				</>
			)}
		</>
	);
};

export default Search;
